module.exports = __webpack_public_path__ + "static/media/table-fill.6490caf6.svg";